var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotAllowedSymbol = function SvgNotAllowedSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.704 55.703",
    style: {
      enableBackground: "new 0 0 55.704 55.703"
    },
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.852 0C19.905 0 12.743 3.363 7.664 8.72c-.036.031-.081.042-.115.076-.054.054-.073.126-.123.184C2.833 13.949 0 20.568 0 27.852c0 15.357 12.493 27.851 27.851 27.851 15.356 0 27.851-12.494 27.851-27.851C55.703 12.494 43.208 0 27.852 0zM4.489 27.851c0-5.315 1.805-10.207 4.806-14.138l32.691 32.694c-3.93 3.001-8.819 4.806-14.135 4.806-12.882 0-23.362-10.481-23.362-23.362zm40.793 15.501-32.933-32.93c4.13-3.678 9.551-5.934 15.503-5.934 12.881 0 23.362 10.48 23.362 23.363-.001 5.952-2.256 11.374-5.932 15.501z"
  })));
};
export default SvgNotAllowedSymbol;